import { styled } from '@mui/material/styles';

import { MOBILE_CONTAINER_WIDTH } from '@mopla/constants';
import { MplSnappingBottomSheet } from '@mopla/ui';

const narrowSheetPaperStyles = {
	'& .MuiPaper-root': {
		maxWidth: MOBILE_CONTAINER_WIDTH,
		width: '100%',
		margin: '0 auto',
	},
};

export const NarrowSnappingBottomSheet = styled(MplSnappingBottomSheet)(
	narrowSheetPaperStyles
);
